import React from 'react';
import {
    View,
    Text,
    Switch,
    StyleSheet
} from 'react-native';
import PropTypes from 'prop-types';

const SwitchText = ({text, value, onValueChange, containerStyleProps}) => {
    return (
        <View style={[styles.mainContainer, containerStyleProps]}>
            <Switch
                value={value}
                onValueChange={onValueChange}
            />

            {
                text !== undefined &&
                <Text style={{
                    textAlign: 'center'
                }}>
                    {text}
                </Text>
            }
        </View>
    )
};

const styles = StyleSheet.create({
    mainContainer: {
        flexDirection: 'row',
        // justifyContent: 'center',
        // alignItems: 'center',
    }
});

SwitchText.propTypes = {
    text: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onValueChange: PropTypes.func.isRequired
};

export {SwitchText};
